import * as React from 'react';
import { ConfigurationTotalPriceContainer } from '../ConfigurationTotalPrice/ConfigurationTotalPriceContainer.js';

const RxGlassesTopBar = ()=>/*#__PURE__*/ React.createElement("div", {
        className: "rxglasses-topbar"
    }, /*#__PURE__*/ React.createElement(ConfigurationTotalPriceContainer, null))
;

export { RxGlassesTopBar };
//# sourceMappingURL=RxGlassesTopBar.js.map
